/** Colores de la clasificación ABC en el camión: A verde, B amarillo, C naranja. */
export const ABC_COLORS: Record<string, string> = { A: '#22c55e', B: '#eab308', C: '#f97316' };
export const NO_ABC_COLOR = '#94a3b8';

/** Color estable de un proveedor (varía con su id para distinguirlo de los demás en un camión compartido). */
export function supplierColor(supplierId: number): string {
  const hue = Math.round(((supplierId * 2654435761) % 360 + 360) % 360);
  return `hsl(${hue} 65% 48%)`;
}
